import { makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  rowsGrid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    columnGap: 16,
    alignItems: 'center'
  },
  rowsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  rows: {
    rowGap: 4,
    maxHeight: 320,
    overflowY: 'auto'
  },
  rowLabel: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 8
  }
})

export default useStyles
